export class CamSoftware {
  constructor(
    public code: number,
    public name: string,
    public mimeTypes: string[]
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/cam-software.ts